export function isValidText(field?: any): boolean {
  if (field && field.value) {
    return field.value.trim() !== '';
  }
  return false;
}
